import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import ClosableTrailer from 'components/shared/closableTrailer/closableTrailer.js';
import { track } from 'utils/tracking';
import s from 'components/templates/about/about.sss';
import HTML from 'components/core/html/html.js';

export default class About extends Component {
	constructor(props) {
		super(props);
		this.watchTrailer = this.watchTrailer.bind(this);
		this.state = {
			showClosableTrailer: false
		};
	}

	watchTrailer(bl) {
		if (bl) track({ a: `trailer-button-click` });
		this.setState({
			showClosableTrailer: bl
		});
	}

	render({ data, isDesktop, active }, { showClosableTrailer }) {
		let {
			title,
			onesheet,
			synopsis,
			director,
			cast,
			writer,
			watchTrailer,
			closableTrailer
		} = data;

		if (typeof onesheet === 'object') {
			onesheet = isDesktop ? onesheet.src_large : onesheet.src;
		}

		return (
			<div class={s.wrapper} id="about" data-section-observed>
				{showClosableTrailer && (
					<ClosableTrailer
						ytid={closableTrailer.ytid}
						didClose={() => this.watchTrailer(false)}
						client={this.props.client}
					/>
				)}
				{title && !isDesktop && <h2 class={s.title}>{title}</h2>}
				{onesheet && <img class={joinClasses(s.oneSheet, active && s.active)} src={onesheet} />}
				<div class={joinClasses(s.flex, active && s.active)}>
					{title && isDesktop && <h2 class={s.title}>{title}</h2>}
					<HTML
						content={synopsis}
						markdown
						p class={s.crew}
					/>
					{director && (
						<p class={s.crew}>
							<div class={s.by}>Directed by:</div>
							{director}
						</p>
					)}
					{writer && (
						<p class={s.crew}>
							<div class={s.by}>Written by:</div>
							{writer}
						</p>
					)}
					{cast && (
						<p class={s.crew}>
							<div class={s.by}>Cast:</div>
							{cast}
						</p>
					)}
					{watchTrailer && <button class={s.watchTrailer} onClick={() => this.watchTrailer(true)}>{watchTrailer.label}</button>}
				</div>
			</div>
		);
	}

}
